import React from 'react';
import { ResponsivePie } from '@nivo/pie'



const PieChart = ({data, x, y, doughnut, isDarkMode}) => {
  const pieData = data.map((row) => {
    return {
      id: row[0], 
      label: row[0],
      value: row[1], 
    };
  });

  const theme = {
    labels: {
      text: {
        fill: isDarkMode ? '#cbd5e1' : '#374151',
      },
    },
    legends: {
      text: {
        fill: isDarkMode ? '#cbd5e1' : '#374151',
      },
    },
    tooltip: {
      container: {
        background: isDarkMode ? '#1e293b' : '#ffffff',
        color: isDarkMode ? '#cbd5e1' : '#111827',
        border: `1px solid ${isDarkMode ? '#475569' : '#d1d5db'}`,
      },
    },
  };

  return (
    <div className={pieData.length > 0 ? 'h-96' : 'h-20'}>
    <ResponsivePie
      data={pieData}
      margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
      innerRadius={doughnut?0.5:0}
      padAngle={0.7}
      cornerRadius={3}
      activeOuterRadiusOffset={8}
      borderWidth={1}
      borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
      arcLinkLabelsSkipAngle={10}
      arcLinkLabelsTextColor={isDarkMode ? '#cbd5e1' : '#374151'}
      arcLinkLabelsThickness={2}
      arcLinkLabelsColor={{ from: "color" }}
      arcLabelsSkipAngle={10}
      arcLabelsTextColor={{ from: "color", modifiers: [["darker", 2]] }}
      theme={theme}
    />
    </div>
  );
};
export default PieChart;
